import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

const NO_AUTORIZADO = 401;
const PROHIBIDO = 403;

export const autenticacionInterceptor: HttpInterceptorFn = (req, next) => {
 const router = inject(Router);

 const handleError = (error: HttpErrorResponse): Observable<never> => {
   switch (error.status) {
     case NO_AUTORIZADO:
       void router.navigate(['/no-autorizado']);
       break;
     case PROHIBIDO:
       void router.navigate(['/inicio']);
       break;
     default:
       break;
   }
   return throwError(() => error);
 };

 return next(req).pipe(catchError(handleError));
};